export default {
  label: {
    company: 'Yritys',
    vat: 'Y-Tunnus',
    first_name: 'Etunimi',
    last_name: 'Sukunimi',
    mobile: 'Puhelinnumero',
    email: 'Sähköposti',
    address: 'Katuosoite',
    zip: 'Postinumero',
    city: 'Paikkakunta',
    country: 'Maa',
    company: 'Yritys',
  },
  confirm: {
    profile_changed: 'Haluatko varmasti poistua tallentamatta?'
  }
}